import React from 'react';

import { withBrowser } from 'src/components/Responsive/WithBrowser';
import { get } from 'src/utils/EntryUtil';
import { Desktop } from './Desktop/Desktop';
import { IEntriesProps } from './IEntries';
import { Mobile } from './Mobile/Mobile';

export interface IScrollWrapperProps extends IEntriesProps {
  isGreaterThanTablet?: boolean;
}

export const ScrollWrapper: React.FC<IScrollWrapperProps> =
  ({ isGreaterThanTablet, ...props }) => isGreaterThanTablet ? <Desktop {...props} /> : <Mobile {...props} />;

export const ScrollWrapperContainer = withBrowser(browser => ({
  isGreaterThanTablet: get(browser.greaterThan, 'tablet', false),
}))(ScrollWrapper);
